import type { RepositoryMain } from "../Domain/RepositoryMain";
import type { IServiceTemplatePDFRequest } from "../Domain/service/IServiceTemplatePDF";

export class UseCaseTemplatePDF {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(payload: IServiceTemplatePDFRequest) {
        return await this.repository.getTemplatePDF(payload);
    }
}